import {VNode} from 'snabbdom';

import {Section, SectionItem} from 'common/components/items-menu/types';
import {DashboardOrigin} from 'common/report/util/bookmark-overrides';
import {EntityType} from 'common/report/util/saved-entities/types';
import {SearchDisplayContext} from 'common/report/util/search/types';
import {HeaderUserInfo} from 'common/widgets/user-list/types';

export const UntitledReportName = `Untitled`;
export const REPORT_HEADER_HEIGHT = 60;

export enum HeaderAction {
  // TODO(@gonzalo): This action is dashboard specific, when boards mode is enabled. Should be use a `slot` the right call instead?
  ToggleGlobalFilters = `toggle-global-filters`,
  Delete = `delete`,
  Rename = `rename`,
  Refresh = `refresh`,
  //** This is for legacy modes, like impact */
  Save = `save`,
  SaveNew = `save-new`,
  Duplicate = `duplicate`,
  // TODO: rename
  Load = `open`,
  Reset = `new`,

  CreatedBy = `created-by`,
  Share = `share`,

  // alerts
  CreateAlert = `create-alert`,
  ManageAlert = `manage-alert`,
  EnableAlerts = `enable-alerts`,

  QuerySampling = `query-sampling`,
  DismissQuerySamplingTour = `dismiss-query-sampling-tour`,
  Undo = `undo`,
  Redo = `redo`,
}

export type ResultsKeysAndValues = {
  name: string;
  displayName: string;
  values: string[];
  displayValues: string[];
  isPercentage?: boolean;
};

export type HeaderCustomAlertParams =
  | {
      isCustomAlertsActionVisible: true;
      enableCustomAlertConditionTypes?: boolean;
      enableAnomalyDetectionControls?: boolean;
      resultsKeysAndValues: ResultsKeysAndValues[];
      customAlertTimeUnit?: string;
      customAlertsDisabledText?: string;
      customAlertIntervalDays?: number;
      bookmarkParams?: TODO;
    }
  | EmptyObj;

export type QueryReportHeaderParams = {
  autoRefreshIntervalMs?: number | null;
  computedAt?: string;
  controlItems?: Array<SectionItem | {slot: string}>;
  displayContext: SearchDisplayContext;
  duplicateReportUrl?: string;
  emptyEntityName?: string;
  entitiesLoading?: boolean;
  entityType: EntityType.Report | EntityType.Dashboard;
  hasUnsavedChanges: boolean;
  hideActions?: HeaderAction[];
  invalidEntity: boolean;
  invalidMessage: string;
  isPublicDashboard?: boolean;
  isTemplateDashboard?: boolean;
  isTemplateDraftDashboard?: boolean;
  isSaveFailed?: boolean;
  toggleGlobalFiltersLabel?: string;
  overflowControlItems: Section[];
  originDashboard?: DashboardOrigin;
  projectAsOfDate?: string;
  projectId: number;
  selectedBookmarkDashboard?: DashboardOrigin;
  selectedEntityDescription: string;
  selectedEntityId: number | null;
  selectedEntityName: string;
  selectedEntityCreator?: HeaderUserInfo;
  selectedEntityEditor?: HeaderUserInfo;
  isSavingBookmark?: boolean;
  trackName: string;
  userId: number;
  workspaceId: number;
  enableBoardsCopying?: boolean;
  boardsTitleBadgeEl?: VNode;
  dashboardsRoute?: DashboardOrigin[];
  headerActionItemsEl?: VNode;

  // permissions
  canWrite: boolean;
  canSave: boolean;
  canShare: boolean;
  isSuperadmin: boolean;
  allowStaffOverride: boolean;

  // sharing-disabled (visibility controls in create-entity-modal)
  visibilityControlsMessage?: string;

  // query sampling
  samplingFactor?: number;
  isQuerySamplingEnabled?: boolean;
  isQuerySamplingActionVisible?: boolean;
  querySamplingDisabledMessage?: string;
  triggerQuerySamplingTourTooltip?: boolean;
} & Partial<HeaderCustomAlertParams>;

export enum SaveModes {
  SaveNew = `save-new`,
  Edit = `edit`,
  Save = `save`,
}
